import { render, staticRenderFns } from "./JobGroupHistoryTable.vue?vue&type=template&id=6d4b9ac7&"
import script from "./JobGroupHistoryTable.vue?vue&type=script&lang=js&"
export * from "./JobGroupHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./JobGroupHistoryTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports